export default __webpack_public_path__ + "static/media/vu.e88f390e.jpg";